import { render, staticRenderFns } from "./Stops.vue?vue&type=template&id=3864af2c"
import script from "./Stops.vue?vue&type=script&lang=js"
export * from "./Stops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports